export async function getForeignBankAccount(foreignBankAccountRepository) {
  return foreignBankAccountRepository.get();
}
